const DateFormData = {
  countries: [
    {
      id: 0,
      fileId: 0,
      countryVariable: "us",
      countryName: "united_states",
      comment: "// Enter 'MM-DD-YYYY' for localized dateform for the US",
      userInput: "",
      validate_expression: `MM-DD-YYYY`,
      correct_expression: "MM-DD-YYYY",
    },
    {
      id: 1,
      fileId: 0,
      countryVariable: "uk",
      countryName: "united_kingdom",
      comment: "// Enter 'YYYY-MM-DD' for localized dateform for the UK",
      userInput: "",
      validate_expression: `YYYY-MM-DD`,
      correct_expression: "YYYY-MM-DD",
    },
    {
      id: 2,
      fileId: 0,
      countryVariable: "jp",
      countryName: "japan",
      comment: "// Enter 'YYYY-MM-DD' for localized dateform for Japan",
      userInput: "",
      validate_expression: `YYYY-MM-DD`,
      correct_expression: "YYYY-MM-DD",
    },
    {
      id: 3,
      fileId: 0,
      countryVariable: "db",
      countryName: "dubai",
      comment: "// Enter 'DD-MM-YYYY' for localized dateform for the Dubai",
      userInput: "",
      validate_expression: `DD-MM-YYYY`,
      correct_expression: "DD-MM-YYYY",
    },
    {
      id: 4,
      fileId: 0,
      countryVariable: "df",
      countryName: "default_format",
      comment: "// Enter 'MM-DD-YYYY' for the default dateform",
      userInput: "",
      validate_expression: `MM-DD-YYYY`,
      correct_expression: "MM-DD-YYYY",
    },
  ],
};
export default DateFormData;
